import {SearchInput, useSearchContext} from '../../../search_input'
import {Layout} from '../../../layout'
import {useFloatingContext} from '../../../floating'

export const SelectSearch = () => {
	const isFloating = useFloatingContext()
	const {search, handleSearch, handleClear, enabled} = useSearchContext()

	if (!enabled) return null

	const handleBlur = e => {
		if (_.isEmpty(isFloating)) return

		// Get the closest floating container to the input
		const floatingEl = e.target.closest('[data-floating-ui-portal]')
		const stillInsideFloating = floatingEl?.contains(e.relatedTarget)

		// refocus the search input if the user clicked on something in floating selects
		if (stillInsideFloating) {
			e.target.focus()
		}
	}

	return (
		<Layout className="select-search" padding={6} width="full" borderBottom>
			<SearchInput value={search} onChange={handleSearch} onClear={handleClear} onBlur={handleBlur} />
		</Layout>
	)
}
